import { InjectionToken } from '@angular/core';
import { FreelancerLocationPwaInterface } from './location.interface';

export const FREELANCER_LOCATION_PWA_PROVIDER = new InjectionToken<
  FreelancerLocationPwaInterface
>('FreelancerLocationPwaInterface');
